import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface EntityListItemShellProps {
  selected?: boolean;
  selectedForBulk?: boolean;
  onClick?: () => void;
  onDoubleClick?: () => void;
  children: React.ReactNode;
}

export function EntityListItemShell({
  selected = false,
  selectedForBulk = false,
  onClick,
  onDoubleClick,
  children,
}: EntityListItemShellProps) {
  return (
    <Card
      className={cn(
        "rounded-none border-x-0 border-t-0 border-b border-sidebar-border cursor-pointer hover:bg-sidebar-accent/80",
        selectedForBulk && "bg-blue-50 dark:bg-blue-950/45 border-l-4 border-l-blue-500 dark:border-l-blue-400",
        !selectedForBulk && selected && "bg-primary/10 dark:bg-primary/15 border-l-4 border-l-primary",
      )}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
    >
      <CardContent className="p-3">{children}</CardContent>
    </Card>
  );
}

